import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { updateObject } from 'helpers/objectHelpers'
import { refElements } from 'components/Canvas/renderer/utils/elementUtils'
import withDevicesForm from 'hocs/extends/withDevicesForm'
import Accordion from 'components/accordions/Accordion'
import ImageCarouselSettings from '../../elementForms/imageCarousel/ImageCarouselSettings'
import ColumnSettings from '../../elementForms/columns/ColumnsSettings'
import ProductCardSettings from '../../elementForms/productCard/ProductCardSettings'
import YoutubeSettings from '../../elementForms/youtube/YoutubeSettings'
import ContainerSettings from '../../elementForms/container/ContainerSettings'
import ProductSliderSettings from '../../elementForms/productSlider/ProductSliderSettings'
import CardSettings from '../../elementForms/card/CardSettings'

const DevicesImageCarouselSettings = withDevicesForm(ImageCarouselSettings)
const DevicesProductSliderSettings = withDevicesForm(ProductSliderSettings)

const SettingsSwitcher = ({
  refElement,
  value,
  value: {
    defaultSettings = {},
    deviceSettings = {},
    columns = [],
    elements = [],
  },
  onChange,
  updateElement,
  element,
}) => {
  const handleUpdate = (val, key) => {
    return onChange(updateObject(value, { [key]: val }))
  }
  const renderForms = () => {
    switch (refElement) {
      case refElements.CARD:
        return (
          <div style={{ margin: 20 }}>
            <CardSettings
              value={defaultSettings}
              onChange={(val) => handleUpdate(val, 'defaultSettings')}
            />
          </div>
        )
      case refElements.CONTAINER:
        return (
          <div style={{ margin: 20 }}>
            <ContainerSettings
              value={defaultSettings}
              onChange={(val) => handleUpdate(val, 'defaultSettings')}
            />
          </div>
        )
      case refElements.PRODUCT_CARD:
        return (
          <div style={{ margin: 20 }}>
            <ProductCardSettings
              value={defaultSettings}
              onChange={(val) => handleUpdate(val, 'defaultSettings')}
            />
          </div>
        )
      case refElements.YOUTUBE:
        return (
          <div style={{ margin: 20 }}>
            <YoutubeSettings
              value={defaultSettings}
              onChange={(val) => handleUpdate(val, 'defaultSettings')}
            />
          </div>
        )
      case refElements.PRODUCT_SLIDER:
        return (
          <Accordion defaultActiveItems={['device']} accordionProps={{ isLargePadded: true }} >
            <DevicesProductSliderSettings
              label="Override setting in each device"
              subValue="device"
              value={deviceSettings}
              onChange={(val) => handleUpdate(val, 'deviceSettings')}
            />
          </Accordion>
        )
      case refElements.IMAGE_CAROUSEL:
        return (
          <Accordion defaultActiveItems={['device']} accordionProps={{ isLargePadded: true }} >
            <DevicesImageCarouselSettings
              label="Override setting in each device"
              subValue="device"
              valueSettings={deviceSettings}
              onChangeSettings={(val) => handleUpdate(val, 'deviceSettings')}
            />
          </Accordion>
        )
      case refElements.COLUMNS:
        return (
          <ColumnSettings
            valueSettings={defaultSettings}
            onChangeSettings={(val) => handleUpdate(val, 'defaultSettings')}
            valueDeviceSettings={deviceSettings}
            onChangeDeviceSettings={(val) => handleUpdate(val, 'deviceSettings')}
            elements={elements}
            onChangeElements={(val) => {
              const newElements = val.map((item) => item.id)
              return handleUpdate(newElements, 'elements')
            }}
            updateElement={updateElement}
            element={element}
          />
        )
      default:
        return <div>unedited settings</div>
    }
  }

  return (
    <div>
      {renderForms()}
    </div>
  )
}

SettingsSwitcher.propTypes = {}
SettingsSwitcher.defaultProps = {}

export default SettingsSwitcher



// WEBPACK FOOTER //
// ./src/components/Canvas/builder/components/panel/SettingSwitcher.js